var map = {
	"./abandonment.svg": 45005,
	"./active.svg": 78252,
	"./blocked-commercial-number.svg": 7585,
	"./contact.svg": 70734,
	"./form-coach.svg": 51845,
	"./goal-reached.svg": 63310,
	"./goal-unreached.svg": 63417,
	"./gym.svg": 92239,
	"./health-issue.svg": 65682,
	"./imported.svg": 32866,
	"./inactive.svg": 94461,
	"./information-curiosity.svg": 92752,
	"./lost-coach.svg": 13921,
	"./lost-women-coach.svg": 44388,
	"./no-budget.svg": 41919,
	"./no-reason.svg": 21856,
	"./no-sector.svg": 37778,
	"./off-topic.svg": 38755,
	"./problem-coach.svg": 29802,
	"./recruited.svg": 69299,
	"./recruiting.svg": 55664,
	"./spam.svg": 14693,
	"./suspended.svg": 46517,
	"./unavailable.svg": 18196,
	"./unreachable-twice.svg": 59855,
	"./unreachable.svg": 38404,
	"./waiting-list.svg": 91140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73616;